import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    fetchSmsTemplateAll,
    createTemplateSms,
    updateTemplateSms,

} from "@/services/smsTemplate";

@Module({
  namespaced: true
})
export default class smsTemplate extends VuexModule {
  // state
    fetchSmsTemplateList = [];

  // Action

  @Action
  public async fetchSmsTemplateAction(payload) {
    try {
      const data = await fetchSmsTemplateAll(payload);
      this.context.commit("setSmsTemplateList", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async createSmsTemplate(payload) {
    try {
      const data = await createTemplateSms(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateSmsTemplate(payload) {
    try {
      const data = await updateTemplateSms(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Mutation
  public setSmsTemplateList(data: any) {
    this.fetchSmsTemplateList = data;
  }

  get GetFetchSmsTemplateList() {
    return this.fetchSmsTemplateList;
  }

}
